// Related purchaser's relationship to the primary purchaser. Values match the CRM's
// `relationship_type` on a related customer (and the marketplace's RELATIONSHIP_TYPE_DATA);
// book-api validates the same closed set (models.RelationshipTypeAllowed).
export const RELATIONSHIP_TYPE = [
  { text: 'Spouse', value: 'Spouse' },
  { text: 'Immediate family', value: 'Immediate family' },
  { text: 'Relative', value: 'Relative' },
  { text: 'Friend', value: 'Friend' },
  { text: 'Others', value: 'Others' },
  { text: 'Not Applicable', value: 'Not applicable' },
];
export default RELATIONSHIP_TYPE;



// WEBPACK FOOTER //
// ./src/constants/relationshipType.js